import { Component, Input } from '@angular/core';
import { SharedService } from '../../shared/shared.service';

@Component({
  selector: '[userDropDown]',
  templateUrl: './user-dropdown-menu.component.html'
})
export class UserDropdownMenuComponent {
  @Input() idUser: string;
  language: JSON = this.sharedService.language;
  constructor(private sharedService: SharedService) { }
}




// WEBPACK FOOTER //
// D:/Projects/Yahoo/Server API/ServerAPI/AdminAngular/src/app/user/user-dropdown-menu/user-dropdown-menu.component.ts